import styled from "@emotion/styled";

export const Container = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 40px;
  align-items: center;
  padding: 0 20px 80px 20px;
  position: relative;
  min-width: 1140px;
`;

export const HeaderContainer = styled.div`
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: start;
  align-items: start;
`;

export const FilterContainer = styled.div`
  box-sizing: border-box;
  padding: 0 20px;
  width: 100%;
  display: flex;
  gap: 40px;
`;

export const FilterGroup = styled.div`
  width: fit-content;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;
export const FilterTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;

  align-items: center;
  justify-content: center;
`;
export const ContentContainer = styled.div`
  box-sizing: border-box;
  padding: 0px 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const TileContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const TileGroup = styled.div`
  width: 100%;
  display: flex;
  gap: 20px;
`;

export const ChartTileContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`;